import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { services } from '../data/mock';

const Services = () => {
  return (
    <section id="servicos" className="py-24 bg-slate-950 relative overflow-hidden">
      {/* Diagonal Accent Top */}
      <div className="absolute top-0 left-0 right-0 h-24 overflow-hidden">
        <div
          className="absolute -top-12 left-0 right-0 h-24 bg-slate-900 transform skew-y-1"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-semibold tracking-wider uppercase text-sm">
            Nossos Serviços
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mt-4 mb-6">
            Áreas de Atuação
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-8" />
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            Soluções completas em engenharia e construção para transformar seus projetos em realidade.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <Card
              key={service.id}
              className="bg-slate-800/30 border-slate-700 overflow-hidden group hover:border-amber-500/50 transition-all duration-500 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="flex items-center gap-2 text-amber-500 text-sm font-medium mb-2">
                    <span className="w-8 h-0.5 bg-amber-500" />
                    <span>0{index + 1}</span>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-amber-500 transition-colors">
                    {service.title}
                  </h3>
                </div>
              </div>
              <CardContent className="p-6">
                <p className="text-slate-400 mb-4 leading-relaxed">{service.description}</p>
                <button className="flex items-center gap-2 text-amber-500 font-medium hover:gap-4 transition-all duration-300">
                  <span>Saiba mais</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>

      {/* Diagonal Accent Bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-24 overflow-hidden">
        <div
          className="absolute -bottom-12 left-0 right-0 h-24 bg-slate-900 transform -skew-y-1"
        />
      </div>
    </section>
  );
};

export default Services;
